import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import Tooltip from 'components/atoms/tooltip';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class UniquePlayersQuantity extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('UniquePlayersQuantity', value));
    }

    render() {
        const {
            uniquePlayersQuantity,
            min = Const.DEFAULT_MIN_UNIQUE_PLAYERS_IN_LINEUP,
            max = Const.DEFAULT_MAX_UNIQUE_PLAYERS_IN_LINEUP,
        } = this.props;

        let options = {};
        for (let i = min; i <= max; i++) {
            options[i] = 1 !== i ? i + ' Unique Players' : i + ' Unique Player';
        }

        const selectedUniquePlayersQuantity = uniquePlayersQuantity.getUniquePlayersQuantity();

        return (
            <div className="input-info">
                <Tooltip subject="Number of unique players in each lineup. Higher number will diversify lineups more." />
                <SimpleSelect
                    key={selectedUniquePlayersQuantity}
                    value={selectedUniquePlayersQuantity}
                    options={options}
                    onChange={::this.onChange}
                    testId="unique-players-number-dropdown"
                    optionTestId="max-{value}-player-option"
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {uniquePlayersQuantity} = state;

    return {
        uniquePlayersQuantity,
    };
}

export default connect(mapStatesToProps)(UniquePlayersQuantity);
